/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-26 17:37:54
 */

export default {
  path: 'openapi',
  component: () => import( /* webpackChunkName: "openapi-list" */ '@/pages/openapi/OpenapiList'),
  meta: {
    title: 'API配置'
  },
  children: [{
      path: 'create',
      component: () => import( /* webpackChunkName: "openapi-create" */ '@/pages/openapi/CreateEdit'),
      meta: {
        title: '添加配置'
      },
    },
    {
      path: ':openapi_id/edit',
      component: () => import( /* webpackChunkName: "openapi-edit" */ '@/pages/openapi/CreateEdit'),
      meta: {
        title: '编辑配置'
      },
    },
    {
      path: ':openapi_id/view',
      component: () => import( /* webpackChunkName: "openapi-view" */ '@/pages/openapi/CreateEdit'),
      meta: {
        title: '查看配置'
      },
    }
  ]
}